import { type Countries } from '@ctct/domain-layer';

import type { TranslationGetter } from '../../../types';
import type { CountriesService as BaseCountriesService } from '../../_shared/Form/services/CountriesService';

export class CountriesService {
  constructor(
    private countries: Countries,
    private t: TranslationGetter,
    private baseCountriesService: BaseCountriesService
  ) {}

  public api() {
    return {
      ...this.baseCountriesService.api(),
    };
  }

  public data() {
    return {
      ...this.baseCountriesService.data(),

      isShowingTaxNumber: (selectedCountryCode?: string) => {
        if (!selectedCountryCode) return false;

        return this.countries.isShowingSingleBillTaxNumber(selectedCountryCode);
      },

      getTaxDisclaimer: (selectedCountryCode?: string) => {
        if (!selectedCountryCode || !this.countries.isShowingSingleBillTaxNumber(selectedCountryCode)) {
          return '';
        }

        return this.t(
          `application-layer.single-bill-info.tax-disclaimer.${selectedCountryCode}` as keyof typeof this.t
        );
      },

      getTaxLabel: (selectedCountryCode?: string) => {
        if (!selectedCountryCode || !this.countries.isShowingSingleBillTaxNumber(selectedCountryCode)) {
          return '';
        }

        return this.t(`application-layer.single-bill-info.tax-label.${selectedCountryCode}` as keyof typeof this.t);
      },
    };
  }

  public handlers() {
    return {
      ...this.baseCountriesService.handlers(),
    };
  }
}
